import React, { useState, useEffect } from 'react';
import {
  DropdownToggle,
  DropdownMenu,
  Nav,
  NavItem,
  NavLink,
  UncontrolledButtonDropdown,
  Badge,
  Button,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from 'react-router-dom';
import avatar1 from '../../../assets/utils/images/avatars/3_avatar-512.webp';
import axios from 'axios';
import GlobalSearchBox from './GlobalSearchBox';
import AdminProfile from 'components/UserManagement/profile/AdminProfile';
import Notification from 'components/JobManagement/Notification/Notification';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import createUserSelector from 'store/users/selector';
import { BsSendArrowUpFill } from "react-icons/bs";
import { openMessageModal } from 'store/customer/actions';
import MessageModal from 'components/Dashboard/services/Admin/Message/MessageModal';
import MessageNotification from 'components/Whatsapp/MessageNotification';
import RequestFootage from 'components/Whatsapp/RequestFootage';


const UserBox = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userSelector = useSelector(createUserSelector);
  const { loginUser } = userSelector;
  const userData = JSON.parse(localStorage.getItem('user'));
  const { email, name, role } = userData;
  const [isOpen, setIsopen] = useState(false);

  const toggle = () => setIsopen(!isOpen);

  const handleLogout = async () => {
    if (userData && userData.email) {
      Swal.fire({
        title: 'Are you sure you want to logout?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, logout',
        cancelButtonText: 'Cancel',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/technician/logout`, {
            email,
          });
          if (response.status === 204) {
            toast.success(response.data.message);
            localStorage.clear();
            history.push('/login');
          }
        }
      });

    }
  };


  return (
    <>
      {/* Render Message Modal */}
      <MessageModal />
      {/* End */}

      {isOpen && <AdminProfile toggle={toggle} isOpen={isOpen} />}
      <div className="header-btn-lg header_vertical_line m-0 p-0 w-100 d-flex align-items-center justify-content-between position-relative">
        <span className="text-white d-xl-none" style={{ fontSize: '32px', fontFamily: 'Rifles2', flexShrink: 0, lineHeight: 1 }}>VIPER</span>

        {/* Centered Search Box with VIPER on its right */}
        <div
          className='d-none d-xl-flex align-items-center'
          style={{
            position: 'absolute',
            left: 'calc(50% - 220px)',
            transform: 'translateX(-50%)',
            gap: '18px',
          }}
        >
          <div style={{ width: '560px', maxWidth: '100%' }}>
            <GlobalSearchBox />
          </div>
          <span className="text-white" style={{ fontSize: '40px', fontFamily: 'Rifles2', flexShrink: 0, lineHeight: 1 }}>VIPER</span>
        </div>

        <div className="widget-content p-0 ms-auto">
          <div className="widget-content-wrapper">
            <div className='d-flex justify-content-center align-items-center gap-3'>
              <RequestFootage />
              <Button color='none' title="Message to Client" onClick={() => dispatch(openMessageModal(true))}>
                <BsSendArrowUpFill color='white' fontSize={25} title='' />
              </Button>
              <MessageNotification />
            </div>
            <Notification />
            <div className="widget-content-left ms-3">
              <UncontrolledButtonDropdown direction="down">
                <DropdownToggle color="link" className='d-flex align-items-center'>
                  <div className='d-flex flex-direction-row  align-items-center'>
                    {/* <img
                      width={42}
                      height={42}
                      className="rounded-circle ms-2"
                      src={loginUser?.profile_image ? loginUser?.profile_image : avatar1}
                      alt=""
                    /> */}

                    <div className='flex flex-direction-column'>
                      <div className='widget-heading ms-3 text-capitalize'>
                        {loginUser?.name ? loginUser?.name : name}
                      </div>
                      <div className="widget-subheading float-left ms-3">{loginUser?.role ? loginUser?.role : role}</div>
                    </div>
                    <FontAwesomeIcon
                      className="opacity-8 ms-3 mb-2"
                      icon={faAngleDown}
                    />
                  </div>
                </DropdownToggle>
                <DropdownMenu className='p-2' >
                  <Nav vertical>
                    <NavItem>
                      <div className='d-block d-xl-none'>
                        <GlobalSearchBox />
                      </div>
                    </NavItem>
                    <NavItem onClick={toggle}>
                      <NavLink>My Account</NavLink>
                    </NavItem>
                    <NavItem onClick={handleLogout}>
                      <NavLink>Logout</NavLink>
                    </NavItem>
                  </Nav>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
          </div>
        </div>
      </div></>
  );
};

export default UserBox;
